const Images = {
  avatarPlaceholder: '/avatars/placeholder.png',
  // Avatars: Men
  m1: '/avatars/m/m1.png',
  m2: '/avatars/m/m2.png',
  m3: '/avatars/m/m3.png',
  m4: '/avatars/m/m4.png',
  m5: '/avatars/m/m5.png',
  m6: '/avatars/m/m6.png',
  m7: '/avatars/m/m7.png',
  m8: '/avatars/m/m8.png',
  m9: '/avatars/m/m9.png',
  m10: '/avatars/m/m10.png',
  m11: '/avatars/m/m11.png',
  m12: '/avatars/m/m12.png',
  m13: '/avatars/m/m13.png',
  m14: '/avatars/m/m14.png',
  m15: '/avatars/m/m15.png',
  m16: '/avatars/m/m16.png',
  m17: '/avatars/m/m17.png',
  m18: '/avatars/m/m18.png',
  m19: '/avatars/m/m19.png',
  m20: '/avatars/m/m20.png',
  m21: '/avatars/m/m21.png',
  m22: '/avatars/m/m22.png',
  // Avatars: Women
  w1: '/avatars/w/w1.png',
  w2: '/avatars/w/w2.png',
  w3: '/avatars/w/w3.png',
  w4: '/avatars/w/w4.png',
  w5: '/avatars/w/w5.png',
  w6: '/avatars/w/w6.png',
  w7: '/avatars/w/w7.png',
  w8: '/avatars/w/w8.png',
  w9: '/avatars/w/w9.png',
  w10: '/avatars/w/w10.png',
  w11: '/avatars/w/w11.png',
  w12: '/avatars/w/w12.png',
  w13: '/avatars/w/w13.png',
  w14: '/avatars/w/w14.png',
  w15: '/avatars/w/w15.png',
  w16: '/avatars/w/w16.png',
  w17: '/avatars/w/w17.png',
  w18: '/avatars/w/w18.png',
  w19: '/avatars/w/w19.png',
  w20: '/avatars/w/w20.png',
  w21: '/avatars/w/w21.png',
  w22: '/avatars/w/w22.png'
}

export default Images
